export default __webpack_public_path__ + "static/media/document@3x.841f1451.jpg";